import React, {useState,useRef} from 'react';
import '../profilesettings.css';
import { cambiarFotoPerfilEstudiante } from '../../../services/EstudianteService';
import Swal from 'sweetalert2';
import Loader from '../../../components/loader';
import { useUser } from '../../../context/userContext';



function FotoPerfil(){
    const [isUploading, setIsUploading] = useState(false);
    const { userData, updateUserData } = useUser();
    const fileRef =  useRef(null);
    const usuario = 'https://firebasestorage.googleapis.com/v0/b/uamlibrary-b1bf8.appspot.com/o/Usuariodeafult.png?alt=media&token=269530ac-2118-404c-a6b3-c198d5155210&_gl=1*177w5p9*_ga*NDY3OTM0Mzk2LjE2ODM4NDE3NDk.*_ga_CW55HF8NVT*MTY4NTQyNzE4MC4xNC4xLjE2ODU0MjgyNTMuMC4wLjA.'
    const usuaria = 'https://firebasestorage.googleapis.com/v0/b/uamlibrary-b1bf8.appspot.com/o/Usuariodefault.png?alt=media&token=3eb4b518-742a-4362-aa22-a8c63ab86399&_gl=1*tt5zuz*_ga*NDY3OTM0Mzk2LjE2ODM4NDE3NDk.*_ga_CW55HF8NVT*MTY4NTQyNzE4MC4xNC4xLjE2ODU0MjgzMzkuMC4wLjA.'
    
    const handleOpenFilePicker = () => {
      if(fileRef.current){
        fileRef.current.click();
      }
    }
    
    const handleChangeFile = (e) => {
      const files = e.target.files;
      if (files && files.length > 0) {
          const file = files[0];
          const fileReader = new FileReader();
  
          fileReader.onload = async function (event) {
              setIsUploading(true);
              try {
                  const base64Image = event.target.result; // La imagen en formato Base64
                  await cambiarFotoPerfilEstudiante(userData.cif, base64Image);
                  updateUserData({ userPic: base64Image})
              } catch (error) {
                  // Manejo de errores
                  Swal.fire('Error', 'Error al actualizar la imagen de perfil', 'error');
              } finally {
                  setIsUploading(false);
              }
          };
  
          fileReader.readAsDataURL(file); // Esto convierte la imagen a Base64
      }
    }
  
   const handleDeletePicture = async () => {
    try {
      setIsUploading(true);
      const defaultPic = userData.sexo === 'M' ? usuario : usuaria;
      await cambiarFotoPerfilEstudiante(userData.cif, defaultPic);
      
      // Actualizar el contexto del usuario con la imagen predeterminada
      updateUserData({ userPic: defaultPic });
      
      setIsUploading(false);
    } catch (e) {
      Swal.fire(e.message);
    }
  };
  
    return(
      <div className='profile-contenido'>
        <div className='profile-fotoDePerfil'>
          {isUploading === true ? <Loader label={'Loading...'}/> : <img src={userData.userPic} alt='logo'/>}
          <div style={isUploading ? {marginLeft:'2rem'} : {}}>
            <button onClick={handleOpenFilePicker} className='profile-btnUsado' >{userData.userPic === usuario || userData.userPic === usuaria ? 'Añadir Foto' : 'Cambiar Foto'}</button>
            {userData.userPic === usuario || userData.userPic === usuaria ? '' : <button className='profile-borrarFoto' onClick={handleDeletePicture}>Borrar Foto</button>}
          </div>
          <input ref={fileRef} 
                type='file' 
                style={{ display: 'none'}} 
                onChange={handleChangeFile} 
                accept='accept="image/png, image/jpeg, image/gif, image/bmp, image/svg+xml, image/webp, image/PNG'/>
        </div>
      </div>
    )
  }
  
  export default FotoPerfil;